import { createContext, useContext } from 'react';

export const TableContext = createContext(null);

export const useTableContext = () => {
  const context = useContext(TableContext);
  if (!context) {
    throw new Error('Table components must be used within a TableContext.Provider');
  }
  return context;
}; 